import { __assign } from 'tslib';
import { Directive, ElementRef, Optional, Input, HostListener, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import Cleave from 'cleave.js';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxCleaveDirective = /** @class */ (function () {
    function NgxCleaveDirective(elementRef, ngControl) {
        this.elementRef = elementRef;
        this.ngControl = ngControl;
    }
    Object.defineProperty(NgxCleaveDirective.prototype, "cleave", {
        set: /**
         * @param {?} cleave
         * @return {?}
         */
        function (cleave) {
            this._cleave = cleave;
            this.setCleave();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgxCleaveDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.ngControl) {
            console.warn('Note: The cleave directive should be used with the ngModel, formControl or formControlName directives.');
            return;
        }
        this._valueAccessor = this.ngControl.valueAccessor;
        this._writeValue = this._valueAccessor.writeValue;
        this._valueAccessor.writeValue = (/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (_this._writeValue) {
                _this._writeValue.call(_this._valueAccessor, value);
            }
            _this.setCleave();
        });
    };
    /**
     * @return {?}
     */
    NgxCleaveDirective.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this._valueAccessor && this._writeValue) {
            this._valueAccessor.writeValue = this._writeValue;
        }
        if (this._cleaveInstance) {
            this._cleaveInstance.destroy();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgxCleaveDirective.prototype.onInput = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this._value = value;
    };
    /**
     * @private
     * @return {?}
     */
    NgxCleaveDirective.prototype.setCleave = /**
     * @private
     * @return {?}
     */
    function () {
        var _this = this;
        if (this._cleaveInstance) {
            this._cleaveInstance.destroy();
        }
        /** @type {?} */
        var el = this.elementRef.nativeElement;
        this._cleaveInstance = new Cleave(el, __assign({}, this._cleave, { onValueChanged: (/**
             * @param {?} __0
             * @return {?}
             */
            function (_a) {
                var target = _a.target;
                if (target.value !== _this._value) {
                    _this.dispatchEvent(el, 'input');
                }
                if (_this._cleave.onValueChanged && typeof _this._cleave.onValueChanged === 'function') {
                    _this._cleave.onValueChanged({ target: target });
                }
            }) }));
        // hack for model -> view cleave
        setTimeout((/**
         * @return {?}
         */
        function () { return _this.dispatchEvent(el, 'input'); }), 0);
    };
    /**
     * @private
     * @param {?} el
     * @param {?} eventType
     * @return {?}
     */
    NgxCleaveDirective.prototype.dispatchEvent = /**
     * @private
     * @param {?} el
     * @param {?} eventType
     * @return {?}
     */
    function (el, eventType) {
        /** @type {?} */
        var event = document.createEvent('Event');
        event.initEvent(eventType, false, false);
        el.dispatchEvent(event);
    };
    NgxCleaveDirective.decorators = [
        { type: Directive, args: [{
                    selector: 'input[cleave],textarea[cleave]',
                },] }
    ];
    /** @nocollapse */
    NgxCleaveDirective.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgControl, decorators: [{ type: Optional }] }
    ]; };
    NgxCleaveDirective.propDecorators = {
        cleave: [{ type: Input }],
        onInput: [{ type: HostListener, args: ['input', ['$event.target.value'],] }]
    };
    return NgxCleaveDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var NgxCleaveDirectiveModule = /** @class */ (function () {
    function NgxCleaveDirectiveModule() {
    }
    NgxCleaveDirectiveModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [NgxCleaveDirective],
                    exports: [NgxCleaveDirective],
                },] }
    ];
    return NgxCleaveDirectiveModule;
}());

export { NgxCleaveDirective, NgxCleaveDirectiveModule };
//# sourceMappingURL=ngx-cleave-directive.js.map
